var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M2 6H14V7H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd5f2",
    d: "M7,11.5c-0.8,0-1.5-0.7-1.5-1.5V2c0-0.8,0.7-1.5,1.5-1.5h2c0.8,0,1.5,0.7,1.5,1.5v6.8 c-1.1,0.5-1.8,1.5-2,2.7H7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M9 1c.6 0 1 .4 1 1v6.5C9 9.1 8.4 10 8.1 11H7c-.6 0-1-.4-1-1V2c0-.6.4-1 1-1H9M9 0H7C5.9 0 5 .9 5 2v8c0 1.1.9 2 2 2h2c0-1.3.8-2.4 2-2.8V2C11 .9 10.1 0 9 0L9 0zM2 5H3V8H2zM13 5H14V8H13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M5.1 6H10.8V7H5.1zM5 15H11V16H5zM8.5 14h-2C4.6 14 3 12.4 3 10.5v-4h1v4C4 11.9 5.1 13 6.5 13h2V14z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M7 13H9V16H7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M12,16c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S14.2,16,12,16z M12,9c-1.7,0-3,1.3-3,3s1.3,3,3,3 s3-1.3,3-3S13.7,9,12,9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M8.5 11.5H15.6V12.5H8.5z",
    transform: "rotate(-45.001 12 12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic--off.81ac315bd477b29aad4d43ae667f0a1f.svg";
export { ForwardRef as ReactComponent };